export default __webpack_public_path__ + "static/media/Baby Care.67b59781.png";